import { RouteConfig } from 'vue-router';

import MailTemplateAdd from '@/views/mailTemplate/Add.vue';

export const mailTemplateAddRoute: RouteConfig = {
  path: 'add',
  name: 'mailTemplateAdd',
  component: MailTemplateAdd,
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.mail-templates.add'
    }
  }
};
